//if a table in a content loop div isn't wrapped like it shoulda been, we wrap the darn thing with the unlimited powers of JQUERY MUAHAHAHAHA
export default function(){
    $(document).ready(function(){
        $('.content-loop table')
        .each(function(){
            if($(this).parent().hasClass('table-wrap') === false){
                $(this).wrap('<div class="table-wrap"></div>');
            }
        });
    });
}
